import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useLang } from '../../../context/LangContext';
import { GlassCard } from '../../shared/GlassCard';
import { staggerContainer, staggerChild } from '../../../animations/variants';

const testimonials = [
  { quoteKey: "testimonials.1.quote", nameKey: "testimonials.1.name", roleKey: "testimonials.1.role", sectorKey: "testimonials.1.sector" },
  { quoteKey: "testimonials.2.quote", nameKey: "testimonials.2.name", roleKey: "testimonials.2.role", sectorKey: "testimonials.2.sector" },
  { quoteKey: "testimonials.3.quote", nameKey: "testimonials.3.name", roleKey: "testimonials.3.role", sectorKey: "testimonials.3.sector" },
];

export const Testimonials = () => {
  const { t } = useLang();

  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 bg-[#020209]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 55, damping: 18 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            {t("testimonials.title")}
          </h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-4"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
        >
          {testimonials.map((item, i) => (
            <motion.div key={i} variants={staggerChild}>
              <GlassCard className="p-6 h-full flex flex-col" data-testid={`testimonial-card-${i}`}>
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} size={14} className="text-yellow-400 fill-yellow-400" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-sm text-neutral-300 italic leading-relaxed flex-1 mb-4">
                  "{t(item.quoteKey)}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/[0.06]">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-green to-brand-blue flex items-center justify-center text-white font-bold text-sm">
                    {t(item.nameKey).charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm text-white font-semibold">{t(item.nameKey)}</p>
                    <p className="text-xs text-neutral-500">{t(item.roleKey)}</p>
                  </div>
                  <span className="ml-auto text-xs px-2.5 py-1 rounded-full bg-brand-green/10 border border-brand-green/20 text-brand-green">
                    {t(item.sectorKey)}
                  </span>
                </div>
              </GlassCard>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
